<template>
    <div>

        <div class="card-body">
            <div class="tab-content">
                <div class="tab-pane active" id="activity">

                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-t">Journal Papers</h5>
                            <hr />
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead class="bg-info">
                                        <tr>
                                            <th>Title of Publication</th>
                                            <th>Complete Name of Journal & Address</th>
                                            <th>Vol. No.</th>
                                            <th>Page No.</th>
                                            <th>Year</th>
                                            <th>HEC Approved Category</th>
                                            <th>Impact Factor</th>
                                            <th>Type</th>
                                            <th style="width: 10px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ind) in journalPapers">
                                            <td>{{item.Title}}</td>
                                            <td>{{item.Description}}</td>
                                            <td>{{item.VolumnNo}}</td>
                                            <td>{{item.PageNo}}</td>
                                            <td>{{item.Year}}</td>
                                            <td>{{item.HECApprovedCategory}}</td>
                                            <td>{{item.ImpactFactor}}</td>
                                            <td>{{item.Type}}</td>
                                            <td style="white-space: nowrap">
                                                <button class="btn btn-sm btn-info" v-on:click="showModalJournalPaper(item, ind)"><i class="fas fa-edit"></i></button>
                                                <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteJournalPaper" v-on:click="journalPaperIndex = ind;"><i class="fas fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="9">
                                                <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showModalJournalPaper()">Add New</button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="modalJournalPaper">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Journal Paper</h4>
                                </div>

                                <form id="labManual" v-on:submit="saveJournalPaper">
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Title of Publication *</label>
                                                    <input max="150" class="form-control" v-model="journalPaper.Title" required />
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Complete Name of Address *</label>
                                                    <input class="form-control" v-model="journalPaper.Description" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Vol. No. </label>
                                                    <input class="form-control" v-model="journalPaper.VolumnNo" />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Page. No. *</label>
                                                    <input class="form-control" v-model="journalPaper.PageNo" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Year</label>
                                                    <input class="form-control" v-mask="'####'" v-model="journalPaper.Year" />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>HEC Approved Category</label>
                                                    <input class="form-control" v-model="journalPaper.HECApprovedCategory" />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Impact Factor</label>
                                                    <input class="form-control" v-model="journalPaper.ImpactFactor" />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Publisher</label>
                                                    <input class="form-control" v-model="journalPaper.Publisher" />
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <div class="custom-control custom-radio">
                                                        <input class="custom-control-input" type="radio" id="customRadio1" value="National" name="customRadio" v-model="journalPaper.Type" required>
                                                        <label for="customRadio1" class="custom-control-label">National</label>
                                                    </div>
                                                    <div class="custom-control custom-radio">
                                                        <input class="custom-control-input" type="radio" id="customRadio2" value="International" name="customRadio" v-model="journalPaper.Type" required>
                                                        <label for="customRadio2" class="custom-control-label">International</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                        <button type="submit" class="btn btn-success">Save changes</button>
                                    </div>
                                </form>

                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>

                    <div class="modal fade" id="modalDeleteJournalPaper">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Delete</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>Are you sure you want to delete this record ?</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer justify-content-between">
                                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                    <button type="button" v-on:click="deleteJournalPaper()" class="btn btn-danger">Delete</button>
                                </div>
                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-c">Conference Papers</h5>
                            <hr />
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead class="bg-info">
                                        <tr>
                                            <th>Title of Publication</th>
                                            <th>Conference</th>
                                            <th>Year</th>
                                            <th>Venue</th>
                                            <th>Type</th>
                                            <th style="width: 10px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ind) in conferencePapers">
                                            <td>{{item.Title}}</td>
                                            <td>{{item.Conference}}</td>
                                            <td>{{item.Year}}</td>
                                            <td>{{item.Venue}}</td>
                                            <td>{{item.Type}}</td>
                                            <td style="white-space: nowrap">
                                                <button class="btn btn-sm btn-info" v-on:click="showModalConferencePaper(item, ind)"><i class="fas fa-edit"></i></button>
                                                <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteConferencePaper" v-on:click="conferencePaperIndex = ind;"><i class="fas fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="6">
                                                <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showModalConferencePaper()">Add New</button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="modalConferencePaper">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Conference Paper</h4>
                                </div>

                                <form id="labManual" v-on:submit="saveConferencePaper">
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Title of Publication *</label>
                                                    <input max="150" class="form-control" v-model="conferencePaper.Title" required />
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Conference *</label>
                                                    <input class="form-control" v-model="conferencePaper.Conference" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Year </label>
                                                    <input class="form-control" v-mask="'####'" v-model="conferencePaper.Year" />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Venue</label>
                                                    <input class="form-control" v-model="conferencePaper.Venue" required />
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <div class="custom-control custom-radio">
                                                        <input class="custom-control-input" type="radio" id="customRadio3" value="National" name="customRadio1" v-model="conferencePaper.Type" required>
                                                        <label for="customRadio3" class="custom-control-label">National</label>
                                                    </div>
                                                    <div class="custom-control custom-radio">
                                                        <input class="custom-control-input" type="radio" id="customRadio4" value="International" name="customRadio1" v-model="conferencePaper.Type" required>
                                                        <label for="customRadio4" class="custom-control-label">International</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                        <button type="submit" class="btn btn-success">Save changes</button>
                                    </div>
                                </form>

                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>

                    <div class="modal fade" id="modalDeleteConferencePaper">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Delete</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>Are you sure you want to delete this record ?</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer justify-content-between">
                                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                    <button type="button" v-on:click="deleteConferencePaper()" class="btn btn-danger">Delete</button>
                                </div>
                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-c">Book/ Book Chapter Publications</h5>
                            <hr />
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead class="bg-info">
                                        <tr>
                                            <th>Title</th>
                                            <th>Subject/ Description</th>
                                            <th>ISBN</th>
                                            <th>Publisher</th>
                                            <th style="width: 10px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ind) in bookPublications">
                                            <td>{{item.Title}}</td>
                                            <td>{{item.Subject}}</td>
                                            <td>{{item.ISBN}}</td>
                                            <td>{{item.Publisher}}</td>
                                            <td style="white-space: nowrap">
                                                <button class="btn btn-sm btn-info" v-on:click="showModalBookPublication(item, ind)"><i class="fas fa-edit"></i></button>
                                                <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteBookPublication" v-on:click="bookPublicationIndex = ind;"><i class="fas fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="5">
                                                <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showModalBookPublication()">Add New</button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="modalBookPublication">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Book Publication</h4>
                                </div>

                                <form id="labManual" v-on:submit="saveBookPublication">
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Title *</label>
                                                    <input max="150" class="form-control" v-model="bookPublication.Title" required />
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Subject/ Description *</label>
                                                    <input class="form-control" v-model="bookPublication.Subject" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>ISBN</label>
                                                    <input class="form-control" v-model="bookPublication.ISBN" />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Publisher</label>
                                                    <input class="form-control" v-model="bookPublication.Publisher" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                        <button type="submit" class="btn btn-success">Save changes</button>
                                    </div>
                                </form>

                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>

                    <div class="modal fade" id="modalDeleteBookPublication">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Delete</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>Are you sure you want to delete this record ?</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer justify-content-between">
                                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                    <button type="button" v-on:click="deleteBookPublication()" class="btn btn-danger">Delete</button>
                                </div>
                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="h4-c">Lab Manuals</h5>
                            <hr />
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead class="bg-info">
                                        <tr>
                                            <th>Title/ Topic</th>
                                            <th>Subject/ Description</th>
                                            <th>Publisher</th>
                                            <th style="width: 10px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, ind) in labManuals">
                                            <td>{{item.Title}}</td>
                                            <td>{{item.Subject}}</td>
                                            <td>{{item.Publisher}}</td>
                                            <td style="white-space: nowrap">
                                                <button class="btn btn-sm btn-info" v-on:click="showModalLabManual(item, ind)"><i class="fas fa-edit"></i></button>
                                                <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalLabManualDelete" v-on:click="labManualIndex = ind;"><i class="fas fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="4">
                                                <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showModalLabManual()">Add New</button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="modalLabManual">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Lab Manual</h4>
                                </div>

                                <form id="labManual" v-on:submit="saveLabManual">
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Title *</label>
                                                    <input max="150" class="form-control" v-model="labManual.Title" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Subject *</label>
                                                    <input class="form-control" v-model="labManual.Subject" required />
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Publisher</label>
                                                    <input class="form-control" v-model="labManual.Publisher" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                        <button type="submit" class="btn btn-success">Save changes</button>
                                    </div>
                                </form>

                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>

                    <div class="modal fade" id="modalLabManualDelete">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Delete</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>Are you sure you want to delete this record ?</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer justify-content-between">
                                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                                    <button type="button" v-on:click="deleteLabManual()" class="btn btn-danger">Delete</button>
                                </div>
                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>

                </div>
            </div>
        </div>

        <div class="card-footer">
            
            <div class="float-right">
                <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
            </div>
        </div>


    </div>
</template>

<script>const axios = require('axios').default;

    export default ({
        props: {
            employeeId: Number,
        },

        data() {
            return {
                journalPapers: [],
                journalPaper: { Title: '', Description: '', VolumnNo: '', PageNo: '', Year: '', HECApprovedCategory: '', ImpactFactor: '', Publisher: '', Type: 'National' },
                journalPaperIndex: -1,

                conferencePapers: [],
                conferencePaper: { Title: '', Conference: '', Year: '', Venue: '', Type: 'National' },
                conferencePaperIndex: -1,

                bookPublications: [],
                bookPublication: { Title: '', Subject: '', Publisher: '', ISBN: '' },
                bookPublicationIndex: -1,

                labManuals: [],
                labManual: { Title: '', Subject: '', Publisher: '' },
                labManualIndex: -1,

            }
        },

        created: function () {
            this.pageLoad();
        },

        methods: {

            pageLoad() {
                startReq();
                var vm = this;
                axios.get('/ApplicantsApi/pageLoadResearch?id=' + vm.employeeId)
                    .then(function (res) {
                        endReq();

                        if (res.data.journalPapers)
                            vm.journalPapers = res.data.journalPapers;

                        if (res.data.conferencePapers)
                            vm.conferencePapers = res.data.conferencePapers;

                        if (res.data.bookPublications)
                            vm.bookPublications = res.data.bookPublications;

                        if (res.data.labManuals)
                            vm.labManuals = res.data.labManuals;


                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            showModalJournalPaper(data, index) {
                if (data) {
                    this.journalPaper = Object.assign({}, data);
                    this.journalPaperIndex = index
                }
                else {
                    this.journalPaper = { Title: '', Description: '', VolumnNo: '', PageNo: '', Year: '', HECApprovedCategory: '', ImpactFactor: '', Publisher: '', Type: 'National' };
                    this.journalPaperIndex = -1;
                }

                $('#modalJournalPaper').modal('show');
            },

            saveJournalPaper(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/ApplicantsApi/saveJournalPaper?id=' + vm.employeeId, {
                    obj: vm.journalPaper
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Saved Successfully", "Done");
                            if (vm.journalPaperIndex == -1)
                                vm.journalPapers.push(res.data.obj);
                            else {
                                vm.journalPapers[vm.journalPaperIndex] = res.data.obj;
                                vm.journalPaperIndex = -1;
                                $('#modalJournalPaper').modal('hide');
                            }

                            vm.journalPaper = { Title: '', Description: '', VolumnNo: '', PageNo: '', Year: '', HECApprovedCategory: '', ImpactFactor: '', Publisher: '', Type: 'National' };
                        }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            deleteJournalPaper() {
                var vm = this;
                startReq();
                axios.get('/ApplicantsApi/deleteJournalPaper?id=' + vm.journalPapers[vm.journalPaperIndex].ApplicantJournalPaperID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Deleted Successfully", "Done!");
                            vm.journalPapers.splice(vm.journalPaperIndex, 1);
                            vm.journalPaperIndex = -1;
                            $('#modalDeleteJournalPaper').modal('hide');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },


            showModalConferencePaper(data, index) {
                if (data) {
                    this.conferencePaper = Object.assign({}, data);
                    this.conferencePaperIndex = index
                }
                else {
                    this.conferencePaper = { Title: '', Conference: '', Year: '', Venue: '', Type: 'National' },
                        this.conferencePaperIndex = -1;
                }

                $('#modalConferencePaper').modal('show');
            },

            saveConferencePaper(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/ApplicantsApi/saveConferencePaper?id=' + vm.employeeId, {
                    obj: vm.conferencePaper
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Saved Successfully", "Done");
                            if (vm.conferencePaperIndex == -1)
                                vm.conferencePapers.push(res.data.obj);
                            else {
                                vm.conferencePapers[vm.conferencePaperIndex] = res.data.obj;
                                vm.conferencePaperIndex = -1;
                                $('#modalConferencePaper').modal('hide');
                            }

                            vm.conferencePaper = { Title: '', Conference: '', Year: '', Venue: '', Type: 'National' };
                        }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            deleteConferencePaper() {
                var vm = this;
                startReq();
                axios.get('/ApplicantsApi/deleteConferencePaper?id=' + vm.conferencePapers[vm.conferencePaperIndex].ApplicantConferencePaperID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Deleted Successfully", "Done!");
                            vm.conferencePapers.splice(vm.conferencePaperIndex, 1);
                            vm.conferencePaperIndex = -1;
                            $('#modalDeleteConferencePaper').modal('hide');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },


            showModalBookPublication(data, index) {

                if (data) {
                    this.bookPublication = Object.assign({}, data);
                    this.bookPublicationIndex = index
                }
                else {
                    this.bookPublication = { Title: '', Conference: '', Year: '', Venue: '', Type: 'National' };
                    this.bookPublicationIndex = -1;
                }

                $('#modalBookPublication').modal('show');
            },

            saveBookPublication(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/ApplicantsApi/saveBookPublication?id=' + vm.employeeId, {
                    obj: vm.bookPublication
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {

                            toastr.success("Saved Successfully", "Done");
                            if (vm.bookPublicationIndex == -1)
                                vm.bookPublications.push(res.data.obj);
                            else {
                                vm.bookPublications[vm.bookPublicationIndex] = res.data.obj;
                                vm.bookPublicationIndex = -1;
                                $('#modalBookPublication').modal('hide');
                            }
                            vm.bookPublication = { Title: '', Subject: '', Publisher: '', ISBN: '' };
                         }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            deleteBookPublication() {
                var vm = this;
                startReq();
                axios.get('/ApplicantsApi/deleteBookPublication?id=' + vm.bookPublications[vm.bookPublicationIndex].ApplicantBookPublicationID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Deleted Successfully", "Done!");
                            vm.bookPublications.splice(vm.bookPublicationIndex, 1);
                            vm.bookPublicationIndex = -1;
                            $('#modalDeleteBookPublication').modal('hide');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },


            showModalLabManual(data, index) {
                if (data) {
                    this.labManual = Object.assign({}, data);
                    this.labManualIndex = index
                }
                else {
                    this.labManual = { Title: '', Subject: '', Publisher: '' };
                    this.labManualIndex = -1;
                }

                $('#modalLabManual').modal('show');
            },

            saveLabManual(e) {
                e.preventDefault();
                var vm = this;
                startReq();
                axios.post('/ApplicantsApi/saveLabManual?id=' + vm.employeeId, {
                    obj: vm.labManual
                })
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Saved Successfully", "Done");
                            if (vm.labManualIndex == -1)
                                vm.labManuals.push(res.data.obj);
                            else {
                                vm.labManuals[vm.labManualIndex] = res.data.obj;
                                vm.labManualIndex = -1;
                                $('#modalLabManual').modal('hide');
                            }

                            vm.labManual = { Title: '', Subject: '', Publisher: '' };
                        }
                        else
                            toastr.error(res.data.msg);

                    }).catch(function (err) {
                        endReq();
                        var res = err.response;
                        if (res.status == 401) {
                            toastr.error(res.data);
                        }
                        else {
                            for (const [key, value] of Object.entries(res.data.errors)) {
                                toastr.error(`${value}`);
                            }
                        }
                    })
            },

            deleteLabManual() {
                var vm = this;
                startReq();
                axios.get('/ApplicantsApi/deleteLabManual?id=' + vm.labManuals[vm.labManualIndex].ApplicantLabManualID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Deleted Successfully", "Done!");
                            vm.labManuals.splice(vm.labManualIndex, 1);
                            vm.labManualIndex = -1;
                            $('#modalLabManualDelete').modal('hide');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            clear() {
                location.reload();
            }

        }
    })</script>

<style>

    .h4-t {
        margin-top: -9px;
        margin-bottom: -5px;
        font-weight: 600
    }

    .h4-c {
        margin-bottom: -5px;
        font-weight: 600
    }
</style>





// WEBPACK FOOTER //
// src/components/applicantResearch.vue